import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Contratante, Conductor, TelefonosContratante } from '../modelos/data-emision.model';
import { ValidaRFC } from 'src/app/utilities/validaRFC';
import { RequestServices } from '../services/request.service';
import { Configuration, Encrypted } from '../Constants/configuration';
import { StorageService } from '../services/storage.service';
import { Prospecto } from '../modelos/prospecto.model';
import { CocheSeguro } from '../modelos/cocheSeguro.model';
import { LogConsumoFunciones } from '../utilities/logConsumo';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CotizacionRenovacionComponent } from '../cotizacion/renovacion/cotizacion-ayuda.component';
import { MatDialog } from '@angular/material/dialog';
import { StyleCocheSeguro } from '../modelos/styleCocheseguro.model';
import { NotificacionComponent } from '../tools/notificacion/notificacion.component';
import { InicioComponent } from '../inicio/inicio.component';
declare var gtag;

@Component({
  selector: 'datos-emision',
  templateUrl: './datos-emision.component.html',
  styleUrls: ['./datos-emision.component.css']
})
export class DatosEmisionRenovacionComponent {
  public const: Configuration = new Configuration();
  public styleCocheSeguro:StyleCocheSeguro = new StyleCocheSeguro();
  value: string = "";
  contratante: Contratante = new Contratante();
  conductor: Conductor = new Conductor();
  dataProspecto: Prospecto = new Prospecto();
  correo: string = "";
  dateContratante: any = {};
  fec_nac: string = "";
  arrayColonia: any = [{ c1: "", c2: "Colonia" }];
  arrayCiudad: any = [{ c1: "", c2: "Ciudad" }];
  telefono: string = "";
  celular: string = "";
  aseguradoraId = 0;
  public visible: boolean = false;
  public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestServices, this.storageService, this.router);
  telefonos: Array<TelefonosContratante> = [
    {
      cve_lada: '',
      cve_lada_nac: '',
      num_tel: '',
      tipo: 2
    },
    {
      cve_lada: '',
      cve_lada_nac: '',
      num_tel: '',
      tipo: 1
    }
  ];

  constructor(private router: Router, private requestServices: RequestServices, private storageService: StorageService, 
    private snackBar: MatSnackBar, private modal: MatDialog) { 
    if (this.storageService.ifExist("styleCocheSeguro")) {
      this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
    }
  }

  ngOnInit(): void {
    gtag({'event':'formStep2View'});
    
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      this.updatelogConsumo();
    }
    if (cocheSeguro?.contratante) {
      this.contratante = cocheSeguro.contratante;
      this.dataProspecto = cocheSeguro.prospecto;
      this.correo = this.dataProspecto.correo;
    } else {
      this.contratante.sexo = (cocheSeguro.sexo ? 'M' : 'F');
      this.dataProspecto = cocheSeguro.prospecto;
      this.correo = this.dataProspecto.correo;
      this.contratante.nombres = this.dataProspecto.nombre;
      this.contratante.direccion.cp = this.dataProspecto.cp;
    }
    this.aseguradoraId = cocheSeguro ?.cia
    let aseguradora_actual = parseInt(this.storageService.getItem("aseguradora_actual"));
    if (this.aseguradoraId === aseguradora_actual) {
      this.visible = true;
    } else {
      this.visible = false;
    }
    this.celular = cocheSeguro ?.celular;
    if (this.celular == ""){
      this.celular = cocheSeguro ?.telefono;
    }
    this.telefono = cocheSeguro ?.telefono;
    this.getCodigoPostal();
    window.scrollTo(0, 0);
  }

  generaRFC() {
    try {
      if (this.isValidDate(parseInt(this.contratante.fec_nac.split("/")[2], 10), parseInt(this.contratante.fec_nac.split("/")[1], 10), parseInt(this.contratante.fec_nac.split("/")[0], 10))) {
        this.fec_nac = this.contratante.fec_nac.split("/")[2] + '-' + this.contratante.fec_nac.split("/")[1] + '-' + this.contratante.fec_nac.split("/")[0];
        let rfcPaso = new ValidaRFC(this.snackBar).calcularRFC(this.contratante.ap_pat, this.contratante.ap_mat, this.contratante.nombres, this.fec_nac);
        this.contratante.rfc = rfcPaso;
      } else {
        this.contratante.fec_nac = "";
        this.fec_nac = "";
        this.contratante.rfc = "";
        this.snackBar.open("¡La fecha de nacimiento es incorrecta!", "favor de utlizar el formato (dd/mm/aaaa)", { duration: this.const.SNACK_BARTIME });
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  isValidDate(year: number, month: number, day: number): boolean {
    let isValidDate: boolean = false;
    try {
      let anos = new Date().getFullYear() - year;
      if ((year.toString().length == 4 && anos > 15 && anos < 99) && (month.toString().length > 0 && month.toString().length < 3 && month < 13) && (day.toString().length > 0 && day.toString().length < 3 && day < 32)) {
        isValidDate = (new Date(year, (month - 1), day) instanceof Date);
      } else {
        console.log("formato de fecha incorrecta");
      }
    } catch (error) {
      console.error("isValidDate", error);
      isValidDate = false;
    }
    return isValidDate;
  }

  getCodigoPostal() {
    if (this.contratante.direccion.cp.length > 4) {
      const dataPrimero = [{ f1: this.contratante.direccion.cp }];
      this.requestServices.getRequest({ projectName: new Configuration().URLPOLIZAS, apiName: 'Sio4CodigoPostalAPI', params: dataPrimero })
        .subscribe(
          result => {
            if (result.error) {
              console.error('Error: ', result.error);
            } else {
              this.arrayColonia = result[0];
              this.arrayCiudad = result[1];
              let cocheSeguro: CocheSeguro = new CocheSeguro();
              if (this.storageService.ifExist("cocheSeguro")) {
                cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
              }
              if (cocheSeguro ?.contratante) {
                this.dateContratante = cocheSeguro ?.contratante;
                this.contratante.direccion.col = this.dateContratante.direccion.col;
              } else {
                this.contratante.direccion.col = result[0][0].c2;
              }
              this.contratante.direccion.ciudad = result[1][0].c2;
              this.contratante.direccion.munId = result[1][0].c3;
              this.contratante.direccion.estado = result[0][0]?.estado;
            }
          }, error => {
            console.error('Error: ', error);
          }
        );
    }
  }

  numericOnly(event): boolean {
    let patt = /^([0-9])$/;
    let result = patt.test(event.key);
    return result;
  }

  next() {
    this.fec_nac = this.contratante.fec_nac.split("/")[2] + '-' + this.contratante.fec_nac.split("/")[1] + '-' + this.contratante.fec_nac.split("/")[0];
    this.contratante.fec_nac_str = this.fec_nac;
    this.telefonos[0].num_tel = this.telefono;
    this.telefonos[1].num_tel = this.celular;
    this.contratante.telefonos = this.telefonos;
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
    }

    cocheSeguro.contratante = this.contratante;
    cocheSeguro.prospecto = this.dataProspecto;
    cocheSeguro.telefono = this.telefono;
    cocheSeguro.celular = this.celular;
    this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
    this.updatelogConsumo();
    gtag({'event':'formStep2Submit'});
    if (this.const.PLATFORM) {
      window.location.href = this.const.URLPLATFORM + 'mi-cuenta/datos-emision-vehiculo-renovacion';
    } else {
      this.router.navigate(['mi-cuenta/datos-emision-vehiculo-renovacion']);
    }
  }

  back() {
    if (this.const.PLATFORM) {
      window.location.href = this.const.URLPLATFORM + 'mi-cuenta/renovacion';
    } else {
      this.router.navigate(['mi-cuenta/renovacion']);
    }
  }

  updatelogConsumo() {
    this.logConsumoFun.logConsumo();
  }

  updateJson() {
    this.fec_nac = this.contratante.fec_nac.split("/")[2] + '-' + this.contratante.fec_nac.split("/")[1] + '-' + this.contratante.fec_nac.split("/")[0];
    this.contratante.fec_nac_str = this.fec_nac;
    this.telefonos[0].num_tel = this.telefono;
    this.telefonos[1].num_tel = this.celular;
    this.contratante.telefonos = this.telefonos;
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
    }

    cocheSeguro.contratante = this.contratante;
    cocheSeguro.prospecto = this.dataProspecto;
    cocheSeguro.telefono = this.telefono;
    cocheSeguro.celular = this.celular;
    this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));

    let parametro = (this.storageService.ifExist("ayuda")) ? 0 : 2;
    this.logConsumoFun.logConsumo(undefined, parametro);
    this.openModalMarcame();
    this.storageService.setItem("ayuda", JSON.stringify(true));
  }

  public fecNacimientoMask: any = {
    mask: [
      {
        mask: '00/00/0000',
        regex: '^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$'
      }
    ]
  };

  openModalMarcame() {
    let modalAyuda = this.modal.open(CotizacionRenovacionComponent, { disableClose: false });
    modalAyuda.afterClosed().subscribe(result => {
    });
  }

  public telefonoMask: any = {
    mask: [
      {
        mask: '0000000000',
        regex: '^[0-9]{10}$'
      }
    ]
  };

  sexoEventListener(sexo) {

    let cocheSeguro: CocheSeguro = new CocheSeguro();

    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));  
      if ((sexo == 'M') !== cocheSeguro.sexo) {
        this.avisoCambioCotizacion();
      }
    }
  }

  limiteLetras(event: KeyboardEvent) {

    this.keyPressBloqueaNumeros(event);
    this.keyPressBloqueaCaracteres(event);

  }

  avisoCambioCotizacion() {
    
    let simpleMess = this.modal.open(NotificacionComponent, { disableClose: true });

    simpleMess.componentInstance.default = true;
    simpleMess.componentInstance.accion = 'ACEPTAR';
    simpleMess.componentInstance.title = 'ERROR EN COTIZACIÓN';
    simpleMess.componentInstance.message = 'Este cambio puede modificar tu cotización.';
    simpleMess.componentInstance.message = "<b class='font-marcameTxt'>Este cambio puede modificar tu cotización.</b>";

  }

  keyPressBloqueaNumeros(event: KeyboardEvent) {

    if (
      event?.key == '0' || event?.key == '1' ||
      event?.key == '2' || event?.key == '3' ||
      event?.key == '4' || event?.key == '5' ||
      event?.key == '6' || event?.key == '7' ||
      event?.key == '8' || event?.key == '9'
    ) {
      event.preventDefault();
    } else {
      (<HTMLInputElement>event.target).value = (<HTMLInputElement>event.target).value;
    }
  }

  keyPressBloqueaCaracteres(event: KeyboardEvent) {

    if(/[!'^+%&/"()=?¿_\-~`*¨;¡#$½ºª·Ç:.´¬€{[\]}\\|<>@,]/gi.test(event.key)) {
      event.preventDefault();
    } else {
      (<HTMLInputElement>event.target).value = (<HTMLInputElement>event.target).value;
    }
  }
  
  limitLetrasNumeros(event) {
    this.keyPressBloqueaCaracteres(event);
  }
}